export default "__VITE_ASSET__DZaTaKKk__"